<script lang="ts">
  import { auth } from '$lib/auth/auth.svelte';
  import { fullLogout } from '$lib/auth/logout';
  import * as m from '$lib/paraglide/messages';

  // Garde anti double-clic. Pas besoin de reset apres logout : en real, Cognito a deja navigue
  // ailleurs (donc ce composant est demonte) ; en mock, le $effect du layout redirige vers /home
  // (idem demontage) avant que l'utilisateur n'ait le temps de re-cliquer.
  let busy = $state(false);

  async function onLogout() {
    if (busy) return;
    busy = true;
    try {
      await fullLogout();
    } catch (err) {
      console.error('Logout failed', err);
      busy = false;
    }
  }
</script>

{#if auth.user}
  <div class="user-menu" role="status">
    <span class="user-name" title={auth.user.email}>{auth.user.name}</span>
    <button type="button" class="logout" onclick={onLogout} disabled={busy}>
      {busy ? m.logout_in_progress() : m.logout_button()}
    </button>
  </div>
{/if}

<style>
  /* Position fixed top-right pour etre present partout (welcome, [map], futurs ecrans) sans
     polluer le flow des pages. z-index 50 pour passer au-dessus des HUD existants. */
  .user-menu {
    position: fixed;
    top: 1rem;
    right: 1rem;
    z-index: 50;
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.4rem 0.6rem;
    background-color: rgba(6, 7, 10, 0.65);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-md);
    backdrop-filter: blur(8px) saturate(120%);
    -webkit-backdrop-filter: blur(8px) saturate(120%);
    font-size: 0.78rem;
  }

  .user-name {
    color: var(--color-on-surface-muted);
    max-width: 14ch;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .logout {
    background: transparent;
    color: var(--color-on-surface);
    border: 1px solid var(--color-border);
    padding: 0.25rem 0.7rem;
    border-radius: var(--radius-sm);
    font-size: 0.75rem;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s, color 0.15s;
  }
  .logout:hover:not(:disabled) {
    background: var(--color-danger, #e25b5b);
    color: white;
    border-color: var(--color-danger, #e25b5b);
  }
  .logout:disabled {
    opacity: 0.5;
    cursor: wait;
  }
</style>
